// Constants.ts - Constants Module
// (c) Marco Vieth, 2023
// https://benchmarko.github.io/CPCBasicTS/
//

export const enum ModelPropID { // eslint-disable-line no-shadow
	arrayBounds = "arrayBounds",
	autorun = "autorun",
	basicVersion = "basicVersion",
	bench = "bench",
	canvasType = "canvasType",
	databaseDirs = "databaseDirs",
	database = "database",
	debug = "debug",
	example = "example",
	exampleIndex = "exampleIndex",
	implicitLines = "implicitLines",
	input = "input",
	integerOverflow = "integerOverflow",
	kbdLayout = "kbdLayout",
	linesOnLoad = "linesOnLoad",
	dragElements = "dragElements",
	palette = "palette",
	prettyBrackets = "prettyBrackets",
	prettyColons = "prettyColons",
	prettyLowercaseVars = "prettyLowercaseVars",
	prettySpace = "prettySpace",
	processFileImports = "processFileImports",
	random = "random",
	selectDataFiles = "selectDataFiles",
	showConsoleLog = "showConsoleLog",
	showCpc = "showCpc",
	showDisass = "showDisass",
	showExport = "showExport",
	showGallery = "showGallery",
	showInput = "showInput",
	showInp2 = "showInp2",
	showKbd = "showKbd",
	showKbdSettings = "showKbdSettings",
	showMore = "showMore",
	showOutput = "showOutput",
	showPretty = "showPretty",
	showRenum = "showRenum",
	showResult = "showResult",
	showSettings = "showSettings",
	showVariable = "showVariable",
	showView = "showView",
	sound = "sound",
	speed = "speed",
	trace = "trace"
}
